import { useTranslation } from '../commons/useTranslasion';
import {
  formatarData,
  formatarDataHora,
  formatarDataHoraSegundos,
  formatarHora,
  obterFormatoDataDayjs,
  obterLocaleDayjs,
  obterLocaleDoIdioma
} from './formatters';
import { useEffect } from 'react';
import dayjs from 'dayjs';

// Importar locales do dayjs
import 'dayjs/locale/pt-br';
import 'dayjs/locale/es';
import 'dayjs/locale/en';

/**
 * Hook que retorna funções de formatação de data configuradas com o idioma atual
 * e utilitários para Date Pickers
 */
export const useDateFormatters = () => {
  const { language } = useTranslation();
  
  const localeDayjs = obterLocaleDayjs(language);
  const formatoDataDayjs = obterFormatoDataDayjs(language);
  const localeIntl = obterLocaleDoIdioma(language);

  // Configurar locale do dayjs quando o idioma mudar
  useEffect(() => {
    dayjs.locale(localeDayjs);
  }, [localeDayjs]);

  return {
    // Funções de formatação já configuradas com o idioma atual
    formatarData: (data: Date | string | number | import('dayjs').Dayjs | null | undefined) =>
      formatarData(data, language),
    formatarDataHora: (data: Date | string | number | import('dayjs').Dayjs | null | undefined) =>
      formatarDataHora(data, language),
    formatarDataHoraSegundos: (data: Date | string | number | import('dayjs').Dayjs | null | undefined) =>
      formatarDataHoraSegundos(data, language),
    formatarHora: (data: Date | string | number | import('dayjs').Dayjs | null | undefined, incluirSegundos?: boolean) =>
      formatarHora(data, language, incluirSegundos),
    
    // Utilitários para Date Pickers
    formatoDataDayjs,
    localeDayjs,
    localeIntl,
    
    // Idioma atual
    language
  };
};

